import { request } from '@/utils/request';

export async function queryNotices(): Promise<any> {
  return request('/api/notices');
}

export async function getUser(): Promise<any> {
  return request('/local/auth/get_user_info_by_token');
}

export async function getStaff() {
  return request('/local/wecom/staff');
}

export async function getKnowledgeProduct() {
  return request('/local/knowledge/productNames');
}
